import { QueryClient } from "@tanstack/react-query"

import { IS_DEV } from "@/lib/constants"
import { configureQueryDefaults } from "@/src/graphql/queryDefaults"
import { configureSiteMinimalQueryDefaults } from "@/src/graphql/revampSite"

// Module-scope singleton rather than state inside MyApp: router loaders run
// when the router initializes at import time, before React has rendered
// anything, and they must share this client with the component tree.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Disable the refetch while developing so the page isn't constantly fetching.
      // https://tanstack.com/query/v4/docs/framework/react/guides/window-focus-refetching
      refetchOnWindowFocus: !IS_DEV,
      // Low default stale time so data is fresh, but high enough to not refetch multiple times if the same query is called multiple times in a short span of time.
      staleTime: 5000,
    },
  },
})

configureSiteMinimalQueryDefaults(queryClient)
configureQueryDefaults(queryClient)
